module.exports = __webpack_public_path__ + "favicon-old.17ada8b69b406b4f94cbb332527126e3.1.1.15.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon-old.ico
// module id = 228
// module chunks = 4